import { createI18n } from "vue-i18n";
import { resolveInitialAppLocale } from "../utils/appLocale";
import en from "./locales/en";
import zh from "./locales/zh";

const i18n = createI18n({
    legacy: false,
    locale: resolveInitialAppLocale(),
    fallbackLocale: "en",
    messages: {
        en,
        zh,
    },
});

export default i18n;
